import { cn } from '@modules/lib/lib'

/**
 * 選択可能なコンテナコンポーネント（メーカー・カラートーンのチップ用）.
 * ColorPalette / PresetEditor の右ペインフィルタで共通利用する.
 */
export interface SelectableContainerProps {
  selected: boolean
  onClick: () => void
  children: React.ReactNode
}

export const SelectableContainer = ({ selected, onClick, children }: SelectableContainerProps) => (
  <button
    aria-pressed={selected}
    className={cn(
      'flex shrink-0 items-center gap-3 rounded-lg border bg-white px-4 py-3 transition-colors',
      selected ? 'border-emerald-500 bg-[#F4F4F5]' : 'border-[#E4E4E7]',
      'hover:bg-[#F4F4F5]',
    )}
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
)
